var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-end fixed-top",staticStyle:{"z-index":"100"}},[_c('Menu',{staticClass:"shadow-3",staticStyle:{"max-width":"60vw"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }